module.exports = __webpack_public_path__ + "static/img/map.d449b380.png";